// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Summary__Label {
  font-weight: bold;
  color: var(--smartflip-blue);
  margin: 0.2rem 0;
}
.Summary__Value {
  font-weight: normal;
  color: #333;
}
.Summary__Value--Negative {
  color: red;
}`, "",{"version":3,"sources":["webpack://./libs/features/property-financial-summary/src/lib/PropertyFinancialSummary/PropertyFinancialSummary.component.scss"],"names":[],"mappings":"AACE;EACE,iBAAA;EACA,4BAAA;EACA,gBAAA;AAAJ;AAEE;EACE,mBAAA;EACA,WAAA;AAAJ;AAEI;EACE,UAAA;AAAN","sourcesContent":[".Summary {\n  &__Label {\n    font-weight: bold;\n    color: var(--smartflip-blue);\n    margin: 0.2rem 0;\n  }\n  &__Value {\n    font-weight: normal;\n    color: #333;\n\n    &--Negative {\n      color: red;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
